import React, { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { fromPairs, isEmpty } from 'lodash';
import MagicCodeField from '../components/MagicCodeField';
import { sendCoupon } from '../../user/api/coupon';
import { useProgressContext } from '../../preorder/contexts/useProgressContext';
import { useAuthState } from '../../preorder/plugins/Auth';
import { useSnackbarContext } from '../contexts/menuToast';

export default ({
  afterSendButtonClick,
}) => {
  const { showSnakbar, snackbar } = useSnackbarContext();
  const { start: startProgress, end: endProgress } = useProgressContext();
  const { token } = useAuthState();
  const { search } = useLocation();
  const history = useHistory();
  const { magicCode: paramsMagicCode } = useMemo(
    () => fromPairs([...new URLSearchParams(search).entries()]),
    [search]
  );

  const onSendButtonClick = async (magicCode) => {
    startProgress();

    const result = await sendCoupon(magicCode, token);
    const { status } = result || {};

    endProgress();

    if (status === 'success') await afterSendButtonClick();

    return result;
  };

  useEffect(() => {
    if (
      isEmpty(paramsMagicCode)
      || isEmpty(token)
    ) return;

    (async () => {
      await sendCoupon(paramsMagicCode, token);

      history.replace({
        search: '',
      });

      await afterSendButtonClick();

      showSnakbar('優惠券領取成功。');
    })();
  // eslint-disable-next-line
  }, [paramsMagicCode, history, showSnakbar, token]);

  return (
    <>
      {snackbar}
      <MagicCodeField onSendButtonClick={onSendButtonClick} />
    </>
  );
};
